import http from "@/http-common"

class CalendarDataService {
    getAll(url) {
        return http.get(`calendars${ url }`)
    }

    get(id) {
        return http.get(`calendars/${ id }`)
    }

    post(data) {
        return http.post('calendars', data)
    }

    patch(id, data, headers) {
        return http.patch(`calendars/${ id }`, data, headers)
    }

    delete(id) {
        return http.delete(`calendars/${ id }`)
    }
}

export default new CalendarDataService()